var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-wrapper',{attrs:{"space":"small"}},[_c('v-radio-group',{attrs:{"mandatory":"","label":"Choose the lookup selector type","value":_vm.field.lookupEntity.entity},on:{"change":_vm.changeLookupType}},_vm._l((_vm.lookupTypeChoices),function(choice){return _c('v-radio',{key:choice.value,attrs:{"label":choice.name,"value":choice.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }